import { Typography } from "antd";
import { EllipsisConfig } from "antd/es/typography/Base";
import React from "react";
const { Paragraph } = Typography;

interface IProps {
  text: String;
  ellipsis: EllipsisConfig;
  style?: React.CSSProperties;
  styleText?: React.CSSProperties;
  className?: string;
}

function NafutelTextTruncateComponent({
  text,
  ellipsis = { expandable: false, symbol: "" },
  style = {},
  className,
  styleText,
}: IProps) {
  return (
    <Paragraph
      className={className}
      style={{ marginBottom: 0, ...style }}
      ellipsis={ellipsis}
    >
      <span style={{ ...styleText }}>{text}</span>
    </Paragraph>
  );
}

export default NafutelTextTruncateComponent;
